export class TmpQrresidentsTranslator {
  /**
   * 削除処理用ペイロード作成
   * @param {*} item アイテム
   */
  static toDeletePayload(item) {
    return this.toUpdatePayload(item, "1");
  }
  /**
   * 更新処理用ペイロード作成
   * @param {*} item アイテム
   * @param {*} deleteFlg 1:削除、1以外：更新
   */
  static toUpdatePayload(item, deleteFlg = "0") {
    // nullの値は更新処理の対象にならないため空白文字に変換処理(null->"")
    return {
      tmpqr_id: item.tmpqr_id, // 必須項目
      manage_grp_name: item.group_name, // 仮QRコード発行単位ID
      name_kanji: item.name_kanji || "", // 氏名
      name_kana: item.name_kana || "", // 氏名カナ
      disp_address: item.address || "", // 表示用住所
      remarks: item.remarks || "", // 備考
      birthday: item.birthday || "", // 生年月日
      postal_code: item.postal_code || "", // 郵便番号
      eva_area_name: item.eva_area_name || "", // 避難元地域名
      sex: item.sex || "", // 性別
      vul_reason: item.vul_reason || "", // 要配慮者理由
      pregnancy_flg: item.pregnancy_flg || "", // 妊娠有無
      lodine_tablets_take_status: item.lodine_tablets_take_status || "", // 安定ヨウ素剤服用状況
      lodine_tablets_take_flg: item.lodine_tablets_take_flg || "", // 安定ヨウ素剤服用可否
      lodine_tablets_status: item.lodine_tablets_status || "", // 安定ヨウ素剤所持有無
      lodine_tablets_distribution: item.lodine_tablets_distribution
        ? String(item.lodine_tablets_distribution).padStart(12, "0")
        : "", // 安定ヨウ素剤配布番号 12桁0埋め処理
      delete_flg: deleteFlg, // 1:削除、1以外：更新
      hash: item.hash // 必須項目
    };
  }
}
